<div class="h-[auto]">
	<app-main-header>
		<h1 class="text-lg md:text-3xl mb-[10px] ml-[10px]">
			<span class="text-accentColor">{{ title() }}</span
			><span class="text-mainColor"> {{ titleSuffix() }}</span>
		</h1></app-main-header
	>
	@let offerList = offerList$ | async;
	@if (!!offerList?.length && !!offerList) {
		<div class="flex flex-row items-center pb-3 md:pb-0">
			<button (click)="swipePrev()" aria-label="Pokaż poprzednią ofertę" class="hidden lg:block">
				<i class="fa-solid fa-chevron-left text-accentColor text-3xl"></i>
			</button>
			<swiper [config]="swiperConfig" class="pb-[35px] md:pb-0">
				@for (offer of offerList; track offer.product.id; let i = $index) {
					<ng-template swiperSlide class="md:flex md:justify-center">
						<app-mobile-wrapper>
							<app-offer-box-mobile [offer]="offer" class="md:hidden"></app-offer-box-mobile>
						</app-mobile-wrapper>
						<app-offer-box [offer]="offer" class="hidden md:block h-full pb-[30px]"></app-offer-box>
					</ng-template>
				}
			</swiper>
			<button (click)="swipeNext()" aria-label="Pokaż następną ofertę" class="hidden lg:block">
				<i class="fa-solid fa-chevron-right text-accentColor text-3xl"></i>
			</button>
		</div>
	} @else {
		<app-main-loader></app-main-loader>
	}
</div>
